// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * Help Translations Index
 * @file index.js
 * @description Centralized export of all help translations
 * @description Lazy loading of help translations to reduce bundle size
 * @version v3.2.0
 */
import { validateLoadedTranslations } from './validateTranslations';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '../../../i18n/supportedLanguages.js';

// Idiomas completos disponibles
const COMPLETE_LANGUAGES = [...SUPPORTED_LANGUAGES];

// Lazy imports - solo se cargan cuando se necesitan
export const loadHelpTranslations = async (lang) => {
  try {
    // Si el idioma está completo, cargarlo directamente
    if (COMPLETE_LANGUAGES.includes(lang)) {
      switch (lang) {
        case 'es':
          const es = await import('./helpTranslations.es.js');
          return es.helpTranslationsEs;
        case 'en':
          const en = await import('./helpTranslations.en.js');
          const enTranslations = en.helpTranslationsEn;
          validateLoadedTranslations(enTranslations, 'en');
          return enTranslations;
        case 'pt':
          const pt = await import('./helpTranslations.pt.js');
          return pt.helpTranslationsPt;
        case 'fr':
          const fr = await import('./helpTranslations.fr.js');
          return fr.helpTranslationsFr;
        case 'de':
          const de = await import('./helpTranslations.de.js');
          return de.helpTranslationsDe;
        case 'it':
          const it = await import('./helpTranslations.it.js');
          return it.helpTranslationsIt;
        case 'nl':
          const nl = await import('./helpTranslations.nl.js');
          return nl.helpTranslationsNl;
        case 'ru':
          const ru = await import('./helpTranslations.ru.js');
          return ru.helpTranslationsRu;
        case 'sv':
          const sv = await import('./helpTranslations.sv.js');
          return sv.helpTranslationsSv;
        case 'zh':
          const zh = await import('./helpTranslations.zh.js');
          return zh.helpTranslationsZh;
        case 'ja':
          const ja = await import('./helpTranslations.ja.js');
          return ja.helpTranslationsJa;
        case 'ko':
          const ko = await import('./helpTranslations.ko.js');
          return ko.helpTranslationsKo;
        case 'ar':
          const ar = await import('./helpTranslations.ar.js');
          return ar.helpTranslationsAr;
        case 'hi':
          const hi = await import('./helpTranslations.hi.js');
          return hi.helpTranslationsHi;
        case 'tr':
          const tr = await import('./helpTranslations.tr.js');
          return tr.helpTranslationsTr;
        case 'pl':
          const pl = await import('./helpTranslations.pl.js');
          return pl.helpTranslationsPl;
        case 'el':
          const el = await import('./helpTranslations.el.js');
          return el.helpTranslationsEl;
        case 'he':
          const he = await import('./helpTranslations.he.js');
          return he.helpTranslationsHe;
      }
    }
    
    // Si llegamos aquí, el idioma no está en la lista de completos
    // Fallback al idioma canónico
    console.warn(`🌐 [HELP_LOADER] Idioma ${lang} no reconocido, usando ${DEFAULT_LANGUAGE} como fallback`);
    const defaultLocale = await import('./helpTranslations.es.js');
    return defaultLocale.helpTranslationsEs;
    
  } catch (error) {
    console.error('Error loading help translations:', error);
    // Fallback al idioma canónico si hay error
    const fallback = await import('./helpTranslations.es.js');
    return fallback.helpTranslationsEs;
  }
};

// Exportación síncrona para idiomas ya cargados (opcional, para casos donde ya están en memoria)
export const getHelpTranslationsSync = (lang, cachedTranslations = {}) => {
  return cachedTranslations[lang] || null;
};

